<section class="proposals">

  <h2 id="product-proposals-title" class="container">Propostas</h2>

  <div class="scrollable-container">

    <div class="scrollable-item">

      <table>

        <caption>Tabela de proostas</caption>

        <tr>
          <th id="proposal-date">Data</th>
          <th id="proposal-person">Nome</th>
          <th id="proposal-value">Valor</th>
          <th id="proposal-status">Status</th>
        </tr>

        <tr *ngFor="let proposal of data.proposals">
          <td>{{proposal.proposal_date | date: 'dd/MM/yyyy' }}</td>
          <td>{{proposal.name}}</td>
          <td>{{proposal.value.currency}} {{proposal.value.value | number : '1.2' : 'pt_br' }}</td>
          <td [class]="proposal.status">{{proposal.status}}</td>
        </tr>

      </table>

    </div>

  </div>

</section>